import { DEFAULT_CHAT_WINDOW_FONT_FAMILY } from '@conversed/shared/src/central/types/webclient-config.type';
import type { ChatWindowState, Config } from '../types/configs';

const buildDefaultConfig = (defaultState: ChatWindowState): Config => ({
  options: {
    requireMicrosoftLogin: false,
    useAttachment: false,
    menuTemplate: [],
    messagePlaceholder: 'Type here',
    welcomeMessage: 'Hi there! I am here to chat with you. Ready to start? 😊',
    waitingForTheBotResponseMessage:
      'Please wait for the bot to finish responding.',
    enableWaitingForBotResponseBlocker: false,
    notificationAIGeneratedAnswer: 'AI antwoord',
    defaultState,
    headerType: 'normal',
    title: 'Conversed',
    subtitle: 'AI powered chatbot',
    refParam: 'normal',
    greeting: {
      buttonText: "Let's go!",
      allowLaterButton: true,
    },
    icons: {
      chatIcon: {
        open: '/images/btn_close.svg',
        closed: '/images/btn_open.svg',
      },
      logo: {
        type: 'circle',
        path: '/images/cvlogo.png',
      },
      speechIcon: '/images/cvlogo.png',
    },
    fonts: {
      chatWindow: DEFAULT_CHAT_WINDOW_FONT_FAMILY,
    },
    useStreamingResponse: false,
  },
  scheme: {
    header: {
      headerColor: '#0554e3',
      headerTitleColor: '#FFFFFF',
      headerSubtitleColor: '#FFFFFF',
      windowColor: '#FFFFFF',
      messageBarColor: '#F2F2F2',
    },
    message: {
      messageBubbleColor: '#0554e3',
      messageBubbleTextColor: '#FFFFFF',
      personalMessageBubbleColor: '#F7F7F7',
      personalMessageBubbleTextColor: '#3D3D3D',
      buttonEdgeColor: '#0554e3',
      buttonTextColor: '#0554e3',
      buttonHoverColor: '#90a9ca',
      buttonBackgroundColor: '#FFFFFF',
      carouselBackgroundColor: '#FFFFFF',
      carouselButtonColor: '#0554e3',
      carouselTextColor: '#000',
      carouselButtonTextColor: '#FFFFFF',
      submitButtonColor: '#0554e3',
      notificationAIGeneratedAnswerTextColor: '#bdbdbd',
      streamingIndicatorColor: '#99a1af',
      urlColor: '#0000EE',
      urlHoverColor: '#0000EE',
      urlClickColor: '#0000EE',
      urlTextDecoration: 'underline',
    },
    greeting: {
      titleColor: '#FFFFFF',
      subtitleColor: '#FFFFFF',
      buttonTextColor: '#FFF',
      buttonColor: '#0554e3',
      backgroundColor: '#FFFFFF',
    },
  },
  mappingId: '',
  configId: 'default',
});

export const DEFAULT_CHATBOT_CONFIG_FULLSCREEN: Config =
  buildDefaultConfig('fullscreen');

export const DEFAULT_CHATBOT_CONFIG_GREETING: Config =
  buildDefaultConfig('greeting');
